import { render } from "./ImagesPrimeHairBis.vue?vue&type=template&id=e6102266"
import script from "./ImagesPrimeHairBis.vue?vue&type=script&lang=js"
export * from "./ImagesPrimeHairBis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__